import { DISPLAY_NO_NAME_CUSTOM_PRODUCT_MODAL } from '../constants';

export const displayNoNameCustomProductModal = (state = {}, action) => {
    switch (action.type) {
        case DISPLAY_NO_NAME_CUSTOM_PRODUCT_MODAL:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
}